/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * 
 * @export
 * @interface Viewport
 */
export interface Viewport {
    /**
     * 
     * @type {Location}
     * @memberof Viewport
     */
    low?: Location;
    /**
     * 
     * @type {Location}
     * @memberof Viewport
     */
    high?: Location;
}

/**
 * Check if a given object implements the Viewport interface.
 */
export function instanceOfViewport(value: object): value is Viewport {
    return true;
}

export function ViewportFromJSON(json: any): Viewport {
    return ViewportFromJSONTyped(json, false);
}

export function ViewportFromJSONTyped(json: any, ignoreDiscriminator: boolean): Viewport {
    if (json == null) {
        return json;
    }
    return {
        
        'low': json['low'] == null ? undefined : LocationFromJSON(json['low']),
        'high': json['high'] == null ? undefined : LocationFromJSON(json['high']),
    };
}

export function ViewportToJSON(json: any): Viewport {
    return ViewportToJSONTyped(json, false);
}

export function ViewportToJSONTyped(value?: Viewport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'low': LocationToJSON(value['low']),
        'high': LocationToJSON(value['high']),
    };
}

